export default function CarouselSection() {
  const items = [
    {
      title: '2026暑期档热映大片合集',
      desc: '暑期档最值得看的十部大片，动作、科幻、动画一网打尽，陪你度过炎炎夏日。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20marathon%20theme%20with%20cinematic%20explosion%20effects%2C%20warm%20sunset%20cinema%20screen%20silhouette%2C%20action%20movie%20poster%20collage%2C%20golden%20hour%20outdoor%20cinema%20vibe%2C%20epic%20film%20atmosphere%2C%20dramatic%20sky&width=1200&height=600&seq=carousel-01-2026&orientation=landscape',
      tag: '暑期特辑',
    },
    {
      title: '悬疑烧脑剧单：高能反转合集',
      desc: '一口气刷完的超高能悬疑剧，每部都有意想不到的结局，侦探迷千万不要错过。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20and%20thriller%20film%20noir%20atmosphere%20with%20dark%20alley%20and%20magnifying%20glass%2C%20detective%20board%20with%20red%20strings%2C%20dramatic%20shadows%20and%20fog%2C%20cinematic%20suspense%20lighting%2C%20crime%20scene%20investigation%20aesthetic&width=1200&height=600&seq=carousel-02-2026&orientation=landscape',
      tag: '悬疑专场',
    },
    {
      title: '韩剧必看清单：从入门到入坑',
      desc: '收视率口碑双丰收的韩剧精选，从经典老剧到最新热播，一篇带你入坑韩剧世界。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20cherry%20blossom%20street%2C%20warm%20spring%20lighting%2C%20couple%20silhouette%20under%20blossoming%20trees%2C%20soft%20pastel%20color%20palette%2C%20Seoul%20cityscape%20background%2C%20emotional%20and%20heartwarming%20atmosphere&width=1200&height=600&seq=carousel-03-2026&orientation=landscape',
      tag: '韩剧推荐',
    },
    {
      title: '国漫崛起：不可错过的国产佳作',
      desc: '近年来国漫精品层出不穷，从玄幻到科幻，画风精良剧情在线，国产动画的骄傲。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20epic%20fantasy%20scene%20with%20ancient%20Chinese%20architecture%20and%20floating%20mountains%2C%20traditional%20ink%20painting%20style%20blended%20with%20modern%203D%20rendering%2C%20dynamic%20martial%20arts%20pose%2C%20golden%20and%20red%20color%20scheme&width=1200&height=600&seq=carousel-04-2026&orientation=landscape',
      tag: '国漫精选',
    },
    {
      title: '周末放松：轻松喜剧片单推荐',
      desc: '忙碌一周后最需要的解压神器，搞笑电影、轻松剧集，让你笑着度过周末时光。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20and%20cheerful%20comedy%20film%20theme%20with%20colorful%20popcorn%20and%20film%20reel%2C%20sunny%20living%20room%20with%20large%20TV%20screen%2C%20happy%20friends%20watching%20movie%20together%20on%20couch%2C%20warm%20and%20joyful%20atmosphere%2C%20cozy%20weekend%20vibe&width=1200&height=600&seq=carousel-05-2026&orientation=landscape',
      tag: '轻松一刻',
    },
  ];

  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精心策划的影视专题，带你发现更多精彩内容
          </p>
        </div>

        <div className="flex flex-col gap-5 max-w-7xl mx-auto">
          {items.map((item, i) => (
            <div
              key={i}
              className={`flex flex-col ${
                i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-6 bg-background-50 rounded-2xl overflow-hidden border border-background-200 cursor-pointer group`}
            >
              <div className="lg:w-[420px] flex-shrink-0 h-56 md:h-64 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 flex flex-col justify-center p-6 md:p-8">
                <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3 whitespace-nowrap w-fit">
                  {item.tag}
                </span>
                <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950 mb-3">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center gap-2 text-primary-500 text-sm font-medium">
                  <span>浏览专题</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}